export default {
  holidays: []
};
